import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import moment from 'moment';

const SpacesRepository = RepositoryFactory.get('spaces');

// initial state
// shape: [{ id, quantity }]
const state = {
    templateSpaces: [],
    lastUpdateTime: null
};

const CACHE_TIME_MS = 2 * 60 * 1000; // 2 minutes in ms

// getters
const getters = {
    templateSpaces: (state) => {
        return state.templateSpaces
    },
    lastUpdateTime: (state) => {
        return state.lastUpdateTime;
    }
};

// actions
const actions = {
    async fetchTemplateSpaces({commit, getters}, forceReload = false) {
        if (forceReload || getters.templateSpaces.length === 0 || (getters.lastUpdateTime === null ||
            (moment().valueOf()) - CACHE_TIME_MS > getters.lastUpdateTime)) {
            const {data} = await SpacesRepository.getSpaceTemplates();
            data.forEach(space => {
                space.action = [
                    'edit',
                    'copy',
                    'delete'
                ];
            });
            commit('setLastUpdateTime');
            commit('setTemplateSpaces', {spaces: data});
        }
    }
};

// mutations
const mutations = {
    setTemplateSpaces(state, {spaces}) {
        state.templateSpaces = spaces;
    },
    setLastUpdateTime(state) {
        state.lastUpdateTime = moment().valueOf();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}